import { useEffect } from 'react';
import { Modal } from 'antd';

export const useAuditSwitch = () => {
  useEffect(() => {
    const res = nx.$event.on('course-editing:switch', ({ checked, hasChanged }) => {
      if (checked || !hasChanged) return;
      Modal.info({
        title: '温馨提示',
        content: '内容有变化/已修改，需重新发布',
      });
    });
    return () => res.destroy();
  }, []);
};
